import styled from 'styled-components';

export default (className) => (Component) => styled(Component).attrs({ className })``;
